// material
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useMutation, useQuery, QueryClient } from "react-query";
import { Container, Box, Stack, Typography } from '@mui/material';
import { isEmpty } from "lodash";
// components
import Page from 'components/Page';
// services
import { getUser, updateUser } from "services/adminUser.service";
import { getCorporates } from "services/adminCorporate.service";
import { getApps } from "services/adminApp.service";

import UserForm from "./UserForm";

// ----------------------------------------------------------------------

export default function DashboardApp() {
  const queryClient = new QueryClient();
  const currentUser = useSelector((state) => state.userData?.currentUser);
  
  const { isSuccess: isSuccessUser, data: resUser } = useQuery(["user-edit", { userId: currentUser.uId }], getUser);
  const { isSuccess: isSuccessCorp, data: resCorp } = useQuery(["corporates"], getCorporates);
  const { isSuccess: isSuccessApp, data: resApp } = useQuery(["apps"], getApps);

  const [userState, setUserState] = useState({});
  const [corps, setCorps] = useState([]);
  const [apps, setApps] = useState([]);

  useEffect(() => {
    if (isSuccessUser) {
      setUserState({
        ...resUser,
        gender: resUser.gender === "" ? "man" : resUser.gender,
        country: resUser.country === "" ? "SG" : resUser.country,
        email: resUser.email.length > 0 ? resUser.email[0] : "",
      });
    }
  }, [isSuccessUser, resUser]);

  useEffect(() => {
    if (isSuccessCorp) {
      setCorps(resCorp.map(item => (
        {
          value: item._id,
          label: item.corpName
        }
      )));
    }
  }, [isSuccessCorp, resCorp]);

  useEffect(() => {
    if (isSuccessApp) {
      setApps(resApp.map(item => (
        {
          value: item.code,
          label: item.name
        }
      )));
    }
  }, [isSuccessApp, resApp]);

  const submitUser = useMutation(values => {
    return updateUser({values, userId: currentUser.uId});
  });

  const onSubmitUser = (values) => {
    submitUser.mutate(values, {
      onSuccess: (res) => {
        if (res)
          queryClient.setQueriesData(["user-edit", { userId: currentUser.uId }], res)
      },
      onSettled: () => {
        queryClient.invalidateQueries(["user-edit", { userId: currentUser.uId }]);
      }
    });
  }

  return (
    <Page title="Dashboard">
      <Container maxWidth="xl">
        <Box sx={{ pb: 5 }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              User Information
            </Typography>
          </Stack>

          {
            (isSuccessUser === true && !isEmpty(userState)) && (
              <UserForm 
                initialValues={{
                  ...userState,
                  password: "",
                  confirmPassword: "",
                }}
                corps={corps}
                apps={apps}
                onSubmit={onSubmitUser}
              />
            )
          }
        </Box>
      </Container>
    </Page>
  );
}
